import React from "react";
import commonUtil from "../../../../utils/commonUtil";

const NoGiftItemsMessageWap = ({lables, quantity}) => {
  return (
    <div className="giftlist-no-items-container-wap">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="87"
        height="71"
        viewBox="0 0 87 71"
        fill="none"
      >
        <path
          d="M43.5002 70.5601C67.1202 70.5601 86.268 69.4421 86.268 68.0631C86.268 66.6841 67.1202 65.5662 43.5002 65.5662C19.8802 65.5662 0.732422 66.6841 0.732422 68.0631C0.732422 69.4421 19.8802 70.5601 43.5002 70.5601Z"
          fill="#F5F5F5"
        />
        <path
          d="M5.96387 29.3572H42.0349V68.062H6.99617C6.72297 68.062 6.46096 67.9535 6.26778 67.7603C6.0746 67.5672 5.96607 67.3051 5.96607 67.0319V29.3572H5.96387Z"
          fill="#C0C0C0"
        />
        <path
          opacity="0.2"
          d="M42.0349 29.3572H5.96387V32.1012H26.718L27.4062 68.062L27.8871 32.1012H42.0349V29.3572Z"
          fill="#333333"
        />
        <path
          d="M5.65165 23.4751H42.0337V31.3189H5.65165C5.51534 31.3189 5.38461 31.2647 5.28823 31.1683C5.19185 31.0719 5.1377 30.9412 5.1377 30.8049V23.9913C5.13741 23.9236 5.15049 23.8565 5.17619 23.7939C5.20189 23.7313 5.2397 23.6744 5.28745 23.6264C5.3352 23.5785 5.39196 23.5404 5.45446 23.5144C5.51696 23.4885 5.58397 23.4751 5.65165 23.4751Z"
          fill="#C0C0C0"
        />
        <path
          d="M19.8528 68.0628L19.4756 23.4751H27.3193L27.6943 68.0628H19.8528Z"
          fill="#5C5C5C"
        />
        <path
          d="M56.2509 68.062H42.0435L42.0435 29.3571H57.2744V67.0319C57.2744 67.304 57.1668 67.565 56.975 67.758C56.7833 67.951 56.523 68.0603 56.2509 68.062Z"
          fill="#C0C0C0"
        />
        <path
          opacity="0.2"
          d="M56.2509 68.062H42.0435L42.0435 29.3571H57.2744V67.0319C57.2744 67.304 57.1668 67.565 56.975 67.758C56.7833 67.951 56.523 68.0603 56.2509 68.062Z"
          fill="#333333"
        />
        <path
          opacity="0.2"
          d="M42.0342 29.3572H57.2717V32.1012H48.7684L47.6126 68.062L47.7383 32.1012H42.0342V29.3572Z"
          fill="#333333"
        />
        <path
          d="M57.5847 31.3186H42.034V23.4748H57.5847C57.6522 23.4748 57.719 23.4881 57.7814 23.514C57.8437 23.5398 57.9004 23.5776 57.9481 23.6254C57.9958 23.6731 58.0337 23.7298 58.0595 23.7921C58.0853 23.8545 58.0986 23.9213 58.0986 23.9888V30.8025C58.0989 30.8701 58.0858 30.9372 58.0601 30.9998C58.0344 31.0624 57.9966 31.1193 57.9489 31.1673C57.9011 31.2153 57.8444 31.2533 57.7819 31.2793C57.7194 31.3052 57.6524 31.3186 57.5847 31.3186Z"
          fill="#C0C0C0"
        />
        <path
          opacity="0.2"
          d="M57.5847 31.3186H42.034V23.4748H57.5847C57.6522 23.4748 57.719 23.4881 57.7814 23.514C57.8437 23.5398 57.9004 23.5776 57.9481 23.6254C57.9958 23.6731 58.0337 23.7298 58.0595 23.7921C58.0853 23.8545 58.0986 23.9213 58.0986 23.9888V30.8025C58.0989 30.8701 58.0858 30.9372 58.0601 30.9998C58.0344 31.0624 57.9966 31.1193 57.9489 31.1673C57.9011 31.2153 57.8444 31.2533 57.7819 31.2793C57.7194 31.3052 57.6524 31.3186 57.5847 31.3186Z"
          fill="#333333"
        />
        <path
          d="M47.6133 68.0628L48.2706 23.4751H53.1652L52.5079 68.0628H47.6133Z"
          fill="#5C5C5C"
        />
        <path
          opacity="0.2"
          d="M47.6133 68.0628L48.2706 23.4751H53.1652L52.5079 68.0628H47.6133Z"
          fill="#333333"
        />
        <path
          d="M50.1675 8.67412V8.66309H43.7509C43.3816 8.69384 43.0212 8.79255 42.6877 8.95425C36.1807 11.6806 33.0176 18.8251 31.6191 23.4661H38.1835C38.1835 23.4661 53.7188 8.23296 50.1675 8.67412Z"
          fill="#5C5C5C"
        />
        <path
          opacity="0.5"
          d="M38.1836 23.4754C38.1836 17.447 42.7451 11.6899 49.2522 8.96352C55.7592 6.23717 38.1836 23.4754 38.1836 23.4754Z"
          fill="#333333"
        />
        <path
          d="M51.8427 12.4925H47.0805C46.7765 12.5186 46.4787 12.593 46.1982 12.713C40.5867 14.7379 36.1905 20.0429 33.8193 23.4883H38.6941C38.6941 23.4883 54.6066 12.1616 51.8427 12.4925Z"
          fill="#5C5C5C"
        />
        <path
          opacity="0.5"
          d="M38.7041 23.4751C41.0003 17.5195 45.4714 14.7248 51.0829 12.6999C56.6944 10.675 38.7041 23.4751 38.7041 23.4751Z"
          fill="#333333"
        />
        <path
          d="M19.7776 6.7929V6.77966H13.3456C13.2277 6.77741 13.1114 6.80668 13.0086 6.86447C12.9058 6.92225 12.8204 7.00643 12.7611 7.10832C10.7538 10.181 19.3784 18.2387 25.6494 23.473H32.2138C32.2138 23.473 22.5966 6.29218 19.7776 6.7929Z"
          fill="#5C5C5C"
        />
        <path
          opacity="0.5"
          d="M32.2107 23.4751C25.9485 18.2408 17.3151 10.183 19.3223 7.11037C21.3296 4.03772 32.2107 23.4751 32.2107 23.4751Z"
          fill="#333333"
        />
        <path
          d="M26.4819 11.1003H21.7086C21.6123 11.1026 21.5176 11.1255 21.4309 11.1673C21.3442 11.2092 21.2674 11.269 21.2056 11.3429C19.0793 13.6259 23.8173 19.6102 27.3818 23.4946H32.25C32.25 23.4946 28.6766 10.7165 26.4819 11.1003Z"
          fill="#5C5C5C"
        />
        <path
          opacity="0.5"
          d="M32.2508 23.4749C28.6862 19.5883 23.946 13.6062 26.0746 11.3232C28.2032 9.04022 32.2508 23.4749 32.2508 23.4749Z"
          fill="#333333"
        />
        <path
          d="M73.1701 64.8305L74.8553 64.2856L74.0436 60.2402L72.3584 60.7829L73.1701 64.8305Z"
          fill="#FF8B7B"
        />
        <path
          d="M59.8057 66.2539H61.5747L62.0467 62.1533H60.2755L59.8057 66.2539Z"
          fill="#FF8B7B"
        />
        <path
          d="M61.7457 66.0485H59.5862C59.5516 66.0485 59.518 66.0606 59.4914 66.0828C59.4648 66.105 59.4468 66.1358 59.4406 66.1698L59.1605 67.7448C59.1544 67.7837 59.1569 67.8236 59.1677 67.8615C59.1786 67.8994 59.1976 67.9345 59.2235 67.9643C59.2493 67.9942 59.2813 68.018 59.3173 68.0342C59.3533 68.0503 59.3924 68.0585 59.4318 68.058C60.1266 68.047 60.6317 68.0051 61.5074 68.0051C62.0456 68.0051 63.6691 68.0624 64.4124 68.0624C65.1558 68.0624 65.222 67.3279 64.9154 67.2595C63.539 66.9617 62.489 66.5514 62.0478 66.1566C61.9643 66.0839 61.8564 66.0453 61.7457 66.0485Z"
          fill="#5C5C5C"
        />
        <path
          d="M74.7814 64.0958L72.9395 64.7002C72.9063 64.7111 72.8776 64.7329 72.8584 64.7622C72.8392 64.7914 72.8304 64.8264 72.8337 64.8612L72.9837 66.467C72.9873 66.5058 72.9996 66.5433 73.0198 66.5767C73.0399 66.61 73.0674 66.6384 73.1001 66.6596C73.1328 66.6808 73.1698 66.6944 73.2085 66.6992C73.2472 66.7041 73.2864 66.7001 73.3233 66.6876C73.9851 66.467 74.9314 66.1141 75.7651 65.845C76.7401 65.5296 77.3202 65.3708 78.4628 65.0002C79.1554 64.7796 79.1245 64.0164 78.8113 64.0473C77.3996 64.1841 76.6055 64.4421 75.2291 64.1069C75.084 64.0603 74.9286 64.0565 74.7814 64.0958Z"
          fill="#5C5C5C"
        />
        <path
          d="M65.906 12.53C66.1266 13.0263 66.3736 13.5623 66.6207 14.0741C66.8677 14.5858 67.1192 15.1042 67.3839 15.6071C67.6486 16.11 67.9089 16.6151 68.1912 17.0982C68.4735 17.5813 68.7603 18.0577 69.0625 18.5143C69.2169 18.7349 69.3669 18.9555 69.5301 19.1628L69.7705 19.4694C69.8149 19.5301 69.8644 19.5869 69.9183 19.6393C69.9955 19.7206 70.0896 19.7839 70.194 19.8246C70.3362 19.8708 70.487 19.8843 70.6352 19.8643C71.0868 19.7836 71.5187 19.6174 71.9079 19.3746C72.1285 19.2466 72.3491 19.0989 72.5697 18.9444C72.7902 18.79 73.0108 18.6114 73.2138 18.4592L74.2372 19.304C74.0625 19.5806 73.8694 19.8451 73.6593 20.0959C73.4504 20.3487 73.2241 20.5868 72.9821 20.8083C72.7301 21.0445 72.4569 21.2572 72.166 21.4436C71.8462 21.6538 71.4988 21.8185 71.1337 21.9333C70.707 22.0712 70.2549 22.1127 69.8102 22.0546C69.3334 21.9911 68.8791 21.8125 68.4868 21.534C68.3068 21.4058 68.1385 21.2618 67.9839 21.1039L67.6508 20.7377C67.4302 20.4951 67.2339 20.2437 67.0288 19.9944C66.2838 19.0033 65.6129 17.9586 65.0215 16.8688C64.7281 16.3328 64.448 15.7946 64.1877 15.2453C63.9274 14.6961 63.6738 14.1579 63.4355 13.569L65.906 12.53Z"
          fill="#FF8B7B"
        />
        <path
          d="M62.6656 12.6879C62.3502 14.3489 64.4148 16.7245 64.4148 16.7245L67.4477 15.4187C67.4477 15.4187 67.1323 13.5151 65.9213 12.1409C64.4368 10.4579 63.0119 10.8792 62.6656 12.6879Z"
          fill="#C0C0C0"
        />
        <path
          opacity="0.2"
          d="M64.3052 13.2759C63.4781 12.9803 62.8671 13.0774 62.6465 13.2759C62.7965 14.8552 64.4111 16.7169 64.4111 16.7169L66.5595 15.7927C66.4007 15.0582 65.6 13.7479 64.3052 13.2759Z"
          fill="#333333"
        />
        <path
          d="M72.9561 18.8314L73.9244 16.791L75.2832 18.2115C75.2832 18.2115 74.8971 19.8394 73.6244 19.6321L72.9561 18.8314Z"
          fill="#FF8B7B"
        />
        <path
          d="M74.7022 15.8313L75.7544 17.1349L75.2845 18.2113L73.9258 16.7908L74.7022 15.8313Z"
          fill="#FF8B7B"
        />
        <path
          opacity="0.2"
          d="M74.0436 60.2402L74.4627 62.3269L72.7753 62.8695L72.3584 60.7851L74.0436 60.2402Z"
          fill="#333333"
        />
        <path
          opacity="0.2"
          d="M60.2771 62.1548H62.0483L61.8057 64.2679H60.0322L60.2771 62.1548Z"
          fill="#333333"
        />
        <path
          d="M54.7197 12.7135C57.2718 19.2227 57.5872 26.3651 57.896 27.7856L67.2287 26.1665C67.4493 17.3699 65.2435 12.5083 64.6523 11.368C64.6099 11.2863 64.5469 11.217 64.4695 11.1671C64.3922 11.1172 64.3031 11.0884 64.2112 11.0834C63.9509 11.0658 63.5495 11.0459 63.0554 11.0437C62.7951 11.0437 62.5149 11.0437 62.2238 11.0591C62.0628 11.0591 61.8995 11.0768 61.7363 11.0878C60.4007 11.2419 59.0751 11.4724 57.7659 11.7782C57.5189 11.8334 57.2674 11.8951 57.0248 11.9591C56.7821 12.0231 56.5836 12.0848 56.363 12.1488C55.441 12.4245 54.7197 12.7135 54.7197 12.7135Z"
          fill="#C0C0C0"
        />
        <path
          opacity="0.2"
          d="M55.6299 15.3319C55.9387 16.3509 56.2034 17.3656 56.4262 18.3494C56.7195 16.5693 56.8497 14.7407 56.8497 14.7407L55.6299 15.3319Z"
          fill="#333333"
        />
        <path
          d="M57.415 7.2688C57.8849 8.50183 58.5422 10.7981 57.7966 11.8039C58.6084 12.373 59.6539 13.0127 61.1781 12.8031C62.7023 12.5936 62.2589 11.5965 61.7626 11.1157C60.2803 11.023 60.1348 9.95985 60.2186 8.92534L57.415 7.2688Z"
          fill="#FF8B7B"
        />
        <path
          d="M62.1707 13.2244C62.1707 13.2244 63.3508 12.1568 62.0582 11.0429C61.8895 11.032 61.7202 11.0499 61.5575 11.0958C61.5575 11.0958 63.0067 12.3354 61.3568 12.7722C60.099 12.6939 58.877 12.323 57.7878 11.6892C57.6561 11.7182 57.5302 11.7689 57.415 11.8391C57.8694 12.7501 60.9575 13.4648 60.9575 13.4648C60.9865 13.3209 61.0363 13.1819 61.1053 13.0523C61.4088 13.9042 61.6433 14.779 61.8067 15.6684C62.015 15.6372 62.2207 15.5908 62.4222 15.5294C62.2509 14.6515 62.0299 13.7839 61.7604 12.931C61.9121 13.006 62.0507 13.1051 62.1707 13.2244Z"
          fill="white"
        />
        <path
          opacity="0.2"
          d="M58.553 7.9458L60.2073 8.92517C60.1875 9.16666 60.1875 9.40938 60.2073 9.65087C59.6515 9.66631 58.8 9.19869 58.6434 8.63842C58.5726 8.4147 58.5419 8.1802 58.553 7.9458Z"
          fill="#333333"
        />
        <path
          d="M60.7189 5.5305C62.0159 5.03641 61.8814 1.71891 59.8851 2.20859C58.5352 2.53946 58.6742 2.94753 58.9212 3.8144C59.1683 4.68127 59.8984 5.84372 60.7189 5.5305Z"
          fill="#5C5C5C"
        />
        <path
          d="M56.9293 5.3757C57.3352 7.08518 57.4852 8.10646 58.5131 8.84099C60.0571 9.94388 62.0423 8.78584 62.1658 6.99033C62.2673 5.3735 61.5857 2.84787 59.7748 2.45525C59.3759 2.36622 58.961 2.3807 58.5693 2.49731C58.1776 2.61393 57.8223 2.8288 57.5371 3.1215C57.252 3.41419 57.0464 3.77498 56.94 4.16954C56.8336 4.5641 56.83 4.97932 56.9293 5.3757Z"
          fill="#FF8B7B"
        />
        <path
          d="M57.1742 6.61538C58.4712 6.12128 57.9727 2.86555 55.9765 3.36185C54.6266 3.69272 54.8604 4.46474 55.2398 5.22353C55.6478 6.02644 56.3603 6.9286 57.1742 6.61538Z"
          fill="#5C5C5C"
        />
        <path
          d="M60.1402 0.862802C59.8027 0.000340888 58.0447 -0.621689 57.7249 1.05471C56.247 0.955445 52.7266 3.81635 56.9065 3.80532C58.9733 4.32588 62.035 3.1877 62.0813 1.98996C62.1276 0.792217 60.6475 0.359883 60.1402 0.862802Z"
          fill="#5C5C5C"
        />
        <path
          d="M56.4921 7.02803C56.7148 7.36691 57.0618 7.6046 57.4583 7.68977C57.9744 7.79123 58.173 7.30376 57.9788 6.8229C57.8046 6.38174 57.3171 5.81926 56.8318 5.94058C56.3466 6.0619 56.2142 6.60893 56.4921 7.02803Z"
          fill="#FF8B7B"
        />
        <path
          d="M74.9692 61.7335L72.1149 62.6533C72.1149 62.6533 69.2761 52.3678 68.2041 46.957C67.8754 45.3093 66.9666 43.2072 66.1615 40.7808C65.1446 37.7302 63.9226 34.4458 62.9367 31.8761C61.8955 29.1696 61.1279 27.2263 61.1279 27.2263L67.2313 26.1653C67.2313 26.1653 72.4921 40.4168 73.2244 45.7703C73.9854 51.3377 74.9692 61.7335 74.9692 61.7335Z"
          fill="#5C5C5C"
        />
        <path
          opacity="0.2"
          d="M66.1594 40.7809C65.1426 37.7303 63.9206 34.4459 62.9346 31.8762L63.4331 30.4292C65.1514 32.0924 66.1418 37.6884 66.1594 40.7809Z"
          fill="#333333"
        />
        <path
          d="M64.3216 26.6702C64.3216 26.6702 64.8179 41.9165 64.5973 47.0979C64.3547 52.7756 62.6232 63.8619 62.6232 63.8619H59.3807C59.3807 63.8619 60.1042 53.8101 60.0424 48.2714C59.9652 41.9629 57.9072 27.7885 57.9072 27.7885L64.3216 26.6702Z"
          fill="#5C5C5C"
        />
        <path
          d="M63.0128 63.9288H59.1924V62.7884L63.4628 62.7134L63.0128 63.9288Z"
          fill="#C0C0C0"
        />
        <path
          d="M75.348 61.6851L71.9489 62.7814L71.5938 61.6829L75.3767 60.3992L75.348 61.6851Z"
          fill="#C0C0C0"
        />
        <path
          d="M59.6348 5.40304C59.6591 5.54421 59.7539 5.64568 59.8554 5.62362C59.9569 5.60156 60.001 5.48024 59.9767 5.33907C59.9525 5.1979 59.8576 5.09864 59.7562 5.11849C59.6547 5.13835 59.6017 5.26408 59.6348 5.40304Z"
          fill="#5C5C5C"
        />
        <path
          d="M61.2248 5.12765C61.249 5.26882 61.3439 5.37029 61.4454 5.34823C61.5468 5.32617 61.5909 5.20485 61.5667 5.06368C61.5424 4.92251 61.4476 4.82105 61.3571 4.8431C61.2667 4.86516 61.2005 4.98648 61.2248 5.12765Z"
          fill="#5C5C5C"
        />
        <path
          d="M60.7295 5.28564C60.9719 5.68654 61.2688 6.05179 61.6118 6.37089C61.5275 6.45636 61.4257 6.52251 61.3133 6.56478C61.201 6.60706 61.0808 6.62444 60.9611 6.61573L60.7295 5.28564Z"
          fill="#FF5652"
        />
        <path
          d="M60.4338 7.09459C60.2724 7.10388 60.1107 7.07989 59.959 7.02411C59.8072 6.96833 59.6685 6.88195 59.5515 6.77034C59.5475 6.76644 59.5444 6.76181 59.5423 6.7567C59.5402 6.75158 59.5391 6.7461 59.5391 6.74056C59.5391 6.73503 59.5402 6.72954 59.5423 6.72443C59.5444 6.71932 59.5475 6.71468 59.5515 6.71079C59.5596 6.70335 59.5702 6.69922 59.5813 6.69922C59.5923 6.69922 59.6029 6.70335 59.611 6.71079C59.7416 6.83121 59.8987 6.91914 60.0697 6.96744C60.2406 7.01573 60.4205 7.02302 60.5948 6.98871C60.6059 6.98739 60.617 6.99029 60.626 6.99684C60.635 7.00338 60.6412 7.01309 60.6433 7.02401C60.6453 7.03482 60.6429 7.04596 60.6367 7.05504C60.6305 7.06411 60.621 7.0704 60.6103 7.07254C60.5519 7.08342 60.493 7.09079 60.4338 7.09459Z"
          fill="#5C5C5C"
        />
        <path
          d="M59.0541 4.97487C59.041 4.97797 59.0274 4.97797 59.0144 4.97487C58.9949 4.96451 58.9801 4.94706 58.9732 4.92612C58.9662 4.90518 58.9675 4.88236 58.9769 4.86238C59.0354 4.73979 59.1228 4.6332 59.2315 4.55176C59.3402 4.47032 59.467 4.41644 59.6011 4.39475C59.6234 4.39241 59.6456 4.399 59.663 4.41306C59.6804 4.42713 59.6914 4.44752 59.6938 4.46975C59.6961 4.49198 59.6895 4.51423 59.6755 4.5316C59.6614 4.54897 59.641 4.56005 59.6188 4.56239C59.5153 4.58085 59.4177 4.62369 59.3341 4.68736C59.2505 4.75104 59.1832 4.83372 59.1379 4.92855C59.1306 4.94412 59.1186 4.95698 59.1035 4.9653C59.0885 4.97362 59.0712 4.97697 59.0541 4.97487Z"
          fill="#5C5C5C"
        />
        <path
          d="M61.8076 4.4604C61.7937 4.46119 61.7798 4.45859 61.7672 4.45283C61.7545 4.44707 61.7434 4.43831 61.7348 4.42732C61.6763 4.33984 61.5977 4.26758 61.5056 4.21656C61.4136 4.16554 61.3107 4.13722 61.2054 4.13395C61.183 4.13455 61.1612 4.12635 61.1447 4.1111C61.1282 4.09585 61.1184 4.07476 61.1172 4.05233C61.1166 4.03047 61.1246 4.00923 61.1394 3.99316C61.1543 3.97709 61.1748 3.96745 61.1966 3.96631C61.3299 3.96811 61.4608 4.00191 61.5782 4.06486C61.6957 4.12782 61.7963 4.21808 61.8716 4.32806C61.8847 4.34592 61.8902 4.36824 61.8869 4.39015C61.8836 4.41206 61.8717 4.43176 61.8539 4.44496C61.8406 4.45499 61.8243 4.4604 61.8076 4.4604Z"
          fill="#5C5C5C"
        />
        <path
          d="M62.3431 66.3596C62.1861 66.3552 62.0301 66.3337 61.8777 66.2957C61.8694 66.2936 61.8618 66.2892 61.8559 66.2829C61.85 66.2767 61.8461 66.2688 61.8446 66.2604C61.8429 66.2524 61.8437 66.2441 61.8469 66.2366C61.85 66.2291 61.8554 66.2228 61.8623 66.2185C61.924 66.1787 62.4821 65.828 62.6806 65.9273C62.703 65.9384 62.722 65.9553 62.7356 65.9762C62.7492 65.9972 62.7568 66.0214 62.7578 66.0464C62.7646 66.0867 62.761 66.128 62.7475 66.1666C62.734 66.2052 62.711 66.2397 62.6806 66.267C62.582 66.3354 62.4629 66.3681 62.3431 66.3596ZM61.9968 66.2361C62.299 66.2957 62.5306 66.2846 62.6233 66.203C62.6445 66.1849 62.6604 66.1614 62.6693 66.135C62.6783 66.1086 62.6799 66.0803 62.674 66.053C62.6747 66.0427 62.6724 66.0324 62.6673 66.0234C62.6622 66.0143 62.6545 66.007 62.6453 66.0023C62.5417 65.9493 62.224 66.1015 61.9968 66.2449V66.2361Z"
          fill="#C0C0C0"
        />
        <path
          d="M61.8858 66.2957C61.8785 66.2977 61.8709 66.2977 61.8637 66.2957C61.8572 66.292 61.8519 66.2865 61.8484 66.2798C61.8448 66.2732 61.8433 66.2657 61.8439 66.2582C61.8439 66.2362 61.8659 65.7244 62.0644 65.5568C62.0883 65.5358 62.1164 65.5201 62.1469 65.511C62.1773 65.5019 62.2094 65.4994 62.2409 65.5038C62.2726 65.5036 62.3035 65.5141 62.3283 65.5338C62.3532 65.5534 62.3706 65.581 62.3777 65.6119C62.424 65.8104 62.0865 66.1987 61.9056 66.2979L61.8858 66.2957ZM62.2144 65.5788C62.1969 65.5785 62.1795 65.5816 62.1633 65.5881C62.147 65.5945 62.1321 65.6041 62.1196 65.6163C62.0012 65.7768 61.9363 65.9706 61.9343 66.17C62.1108 66.031 62.3247 65.7288 62.296 65.623C62.296 65.6119 62.296 65.5855 62.2343 65.5788H62.2144Z"
          fill="#C0C0C0"
        />
        <path
          d="M75.0205 64.2757C75.0126 64.2759 75.0047 64.2737 74.9981 64.2694C74.9914 64.2651 74.9861 64.2588 74.983 64.2515C74.9782 64.2447 74.9756 64.2366 74.9756 64.2283C74.9756 64.22 74.9782 64.2119 74.983 64.2052C75.047 64.139 75.6139 63.5787 75.8653 63.625C75.888 63.6299 75.9092 63.6403 75.9269 63.6553C75.9446 63.6703 75.9583 63.6895 75.9668 63.7111C75.9826 63.7462 75.9896 63.7846 75.9873 63.823C75.985 63.8614 75.9734 63.8987 75.9536 63.9316C75.8212 64.1522 75.3161 64.2449 75.0294 64.2779L75.0205 64.2757ZM75.8301 63.7066C75.6889 63.7066 75.3668 63.9625 75.1419 64.1765C75.5323 64.1169 75.8036 64.011 75.8786 63.8875C75.8906 63.8651 75.8968 63.8401 75.8968 63.8147C75.8968 63.7893 75.8906 63.7643 75.8786 63.7419C75.8764 63.7333 75.8717 63.7255 75.865 63.7196C75.8583 63.7137 75.85 63.7099 75.8411 63.7089L75.8301 63.7066Z"
          fill="#C0C0C0"
        />
        <path
          d="M75.021 64.2748H75.0099C75.0026 64.2732 74.996 64.2693 74.9909 64.2638C74.9858 64.2583 74.9824 64.2514 74.9813 64.244C74.9813 64.2241 74.8754 63.7565 75.032 63.5116C75.0541 63.4757 75.0834 63.4447 75.1179 63.4204C75.1524 63.3961 75.1915 63.3792 75.2327 63.3705C75.3452 63.3462 75.396 63.3925 75.4158 63.4344C75.5085 63.6153 75.2239 64.1094 75.0497 64.266C75.0413 64.2721 75.0313 64.2752 75.021 64.2748ZM75.2923 63.4455H75.2504C75.2198 63.4513 75.1909 63.4636 75.1654 63.4815C75.1399 63.4994 75.1185 63.5224 75.1026 63.5491C75.0239 63.7359 75.0054 63.9425 75.0497 64.1403C75.2151 63.9484 75.3982 63.5734 75.343 63.4653C75.3373 63.4575 75.3295 63.4515 75.3205 63.448C75.3116 63.4445 75.3018 63.4436 75.2923 63.4455Z"
          fill="#C0C0C0"
        />
        <path
          d="M56.8757 14.9067C56.6552 15.414 56.4346 15.961 56.214 16.497C55.9934 17.033 55.7905 17.5735 55.5942 18.1161C55.3979 18.6587 55.2037 19.1969 55.0361 19.7395C54.8685 20.2822 54.7097 20.8226 54.5817 21.3564C54.5222 21.6233 54.4582 21.8902 54.4185 22.1505L54.3832 22.3468V22.3953V22.3821C54.3832 22.371 54.3832 22.3534 54.3832 22.338C54.373 22.2718 54.343 22.2103 54.2972 22.1615C54.231 22.1196 54.3281 22.2453 54.5001 22.3291C54.7054 22.4343 54.9194 22.5214 55.1398 22.5894C56.2248 22.8763 57.3313 23.0748 58.4484 23.1828L58.519 24.5062C57.9007 24.6232 57.2749 24.6969 56.6463 24.7268C55.9955 24.7645 55.3426 24.7401 54.6964 24.654C54.3316 24.6065 53.973 24.52 53.6266 24.3959C53.4185 24.3209 53.2183 24.2256 53.0289 24.1114C52.7816 23.963 52.564 23.77 52.387 23.5423C52.1638 23.2508 52.0249 22.9037 51.9855 22.5387C51.9801 22.4498 51.9801 22.3607 51.9855 22.2718V22.1461V22.0843L52.0098 21.8372C52.0362 21.5042 52.087 21.1865 52.1355 20.8645C52.3597 19.6303 52.6753 18.4145 53.0796 17.2272C53.2803 16.6426 53.4854 16.0647 53.7171 15.4934C53.9487 14.9221 54.1737 14.3663 54.4494 13.7861L56.8757 14.9067Z"
          fill="#FF8B7B"
        />
        <path
          d="M54.7211 12.7128C53.8035 13.2091 53.166 16.1914 53.166 16.1914L55.8791 17.8589C55.8791 17.8589 56.5828 16.4803 57.0989 15.3466C58.0871 13.1783 56.5254 11.7379 54.7211 12.7128Z"
          fill="#C0C0C0"
        />
        <path
          d="M58.2045 23.1556L59.989 23.0784L59.1971 24.7768C59.1971 24.7768 57.5163 24.6754 57.7391 23.8702L58.2045 23.1556Z"
          fill="#FF8B7B"
        />
        <path
          d="M61.1655 24.247L60.2766 25.3543L59.2002 24.7675L59.9899 23.0757L61.1655 24.247Z"
          fill="#FF8B7B"
        />
      </svg>
      <div className="giftlist-no-items-text-main-wap">
          {quantity > 0 ? commonUtil.getLabel(
            lables.eventAccountStatement,
            'accountStatement.gift.table.no.gift.text',
          ) : commonUtil.getLabel(
            lables.eventAccountStatement,
            'accountStatement.gift.table.no.gift.wap.text',
          )}
      </div>
      <div className="giftlist-no-items-text-sub-wap">
        {quantity > 0 ? commonUtil.getLabel(
          lables.eventAccountStatement,
          'accountStatement.gift.table.other.filters.text',
        ) : commonUtil.getLabel(
          lables.eventAccountStatement,
          'accountStatement.gift.table.first.purchase.text',
        )}
      </div>
    </div>
  );
};

export default NoGiftItemsMessageWap;
